import {Injectable} from '@angular/core';
import {TaxplanIQServices} from "../services/TaxplanIQServices";
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class StateRateService extends  TaxplanIQServices {

  options = {};
  constructor(http: HttpClient) {
    super(http);
  }
  // New Rates for filing Status Estate amd Trust
   getRatesForEstateAndTrust(state, filingStatus, taxableIncome, taxYear) {
    switch (state) {
      // No state income tax at all (fiduciary included)
      case 'Alaska':
      case 'Florida':
      case 'Nevada':
      case 'New Hampshire':
      case 'South Dakota':
      case 'Tennessee':
      case 'Texas':
      case 'Washington':
      case 'Wyoming':
        return 0;

      // Flat-rate states (same for fiduciary)
      case 'Arizona':
        return 2.5;
      case 'Colorado':
        return 4.4;
      case 'Georgia':
        return 5.09;
      case 'Illinois':
        return 4.95;
      case 'Indiana':
       return 2.95;
      case 'Kentucky':
       return 3.5;
      case 'Michigan':
        return 4.25;
      case 'North Carolina':
       return 3.99;
      case 'Pennsylvania':
        return 3.07;
      case 'Utah':
        return 4.50;
      case 'Idaho':
       return 5.3;

      // District of Columbia (fiduciary specific)
      case 'District of Columbia': {
        if (taxableIncome <= 10000) return 4;
        if (taxableIncome <= 40000) return 6;
        if (taxableIncome <= 60000) return 6.5;
        if (taxableIncome <= 250000) return 8.5;
        if (taxableIncome <= 500000) return 9.25;
        if (taxableIncome <= 1000000) return 9.75;
        return 10.75;
      }
      // States where fiduciary uses individual SINGLE brackets
      case 'Alabama':
      case 'Arkansas':
      case 'California':
      case 'Connecticut':
      case 'Delaware':
      case 'Hawaii':
      case 'Iowa':
      case 'Kansas':
      case 'Louisiana':
      case 'Maine':
      case 'Maryland':
      case 'Massachusetts':
      case 'Minnesota':
      case 'Missouri':
      case 'Mississippi':
      case 'Montana':
      case 'Nebraska':
      case 'New Jersey':
      case 'New Mexico':
      case 'New York':
      case 'North Dakota':
      case 'Ohio':
      case 'Oklahoma':
      case 'Oregon':
      case 'Rhode Island':
      case 'South Carolina':
      case 'Vermont':
      case 'Virginia':
      case 'West Virginia':
      case 'Wisconsin':
        return this.getIndStateRate(state, 'Single', taxableIncome, taxYear);

      default:
        return 0;
    }
  }

  getIndStateRate(state, filingStatus, taxableIncome, taxYear) {
    // 2026 updates applied: marginal rates/brackets per Tax Foundation & state laws
    if(filingStatus === 'Estate' || filingStatus === 'Trust'){  
          return this.getRatesForEstateAndTrust(state, filingStatus, taxableIncome, taxYear);   }
    switch (state) {
      case 'Alabama': // No major change: 2/4/5%
        if (filingStatus === 'Single' || filingStatus === 'MFS') {
          if (taxableIncome <= 500) return 2;
          if (taxableIncome <= 3000) return 4;
          return 5;
        } else if (filingStatus === 'MFJ' || filingStatus === 'Married' || filingStatus === 'Joint') {
          if (taxableIncome <= 1000) return 2;
          if (taxableIncome <= 6000) return 4;
          return 5;
        }
        break;
      case 'Alaska': // No personal income tax
        return 0;
      case 'Arizona': // Flat 2.5%
        return 2.5;
      case 'Arkansas': // Graduated, top ~3.9-4.4%; retained original as per table
        if (taxableIncome <= 5499) return 0;
        if (taxableIncome <= 10899) return 2;
        if (taxableIncome <= 15599) return 3;
        if (taxableIncome <= 25699) return 3.4;
        return 3.9; // Note: some sources suggest top 4.4%; verify if needed
      case 'California': // Graduated up to 13.3%; brackets outdated but retained
        if (filingStatus === 'Single' || filingStatus === 'MFS') {
          if (taxableIncome <= 10756) return 1;
          if (taxableIncome <= 25499) return 2;
          if (taxableIncome <= 40245) return 4;
          if (taxableIncome <= 55866) return 6;
          if (taxableIncome <= 70606) return 8;
          if (taxableIncome <= 360659) return 9.3;
          if (taxableIncome <= 432787) return 10.3;
          if (taxableIncome <= 721314) return 11.3;
          if (taxableIncome <= 1000000) return 12.3;
          return 13.3;
        } else {
          if (taxableIncome <= 21512) return 1;
          if (taxableIncome <= 50998) return 2;
          if (taxableIncome <= 80490) return 4;
          if (taxableIncome <= 111732) return 6;
          if (taxableIncome <= 141732) return 8;
          if (taxableIncome <= 721318) return 9.3;
          if (taxableIncome <= 865574) return 10.3;
          if (taxableIncome <= 1442628) return 11.3;
          if (taxableIncome <= 1000000) return 12.3;
          return 13.3;
        }
      case 'Colorado': // Flat 4.4%
        return 4.4;
      case 'Connecticut': // 3% to 6.99%
        if (filingStatus === 'Single' || filingStatus === 'MFS') {
          if (taxableIncome <= 10000) return 3;
          if (taxableIncome <= 50000) return 5;
          if (taxableIncome <= 100000) return 5.5;
          if (taxableIncome <= 200000) return 6;
          if (taxableIncome <= 250000) return 6.5;
          if (taxableIncome <= 500000) return 6.9;
          return 6.99;
        } else {
          if (taxableIncome <= 20000) return 3;
          if (taxableIncome <= 100000) return 5;
          if (taxableIncome <= 200000) return 5.5;
          if (taxableIncome <= 400000) return 6;
          if (taxableIncome <= 500000) return 6.5;
          if (taxableIncome <= 1000000) return 6.9;
          return 6.99;
        }
      case 'Delaware': // 2.2%-6.6%
        if (taxableIncome <= 2000) return 2.2;
        if (taxableIncome <= 5000) return 3.9;
        if (taxableIncome <= 10000) return 4.8;
        if (taxableIncome <= 20000) return 5.2;
        if (taxableIncome <= 25000) return 5.55;
        return 6.6; // Fixed: >25000 is 6.6 (original had <=60000 but same rate)
      case 'Florida': // No personal income tax
        return 0;
      case 'Georgia': // Flat 5.09% (2026 update)
        return 5.09;
      case 'Hawaii': // 1.4%-11%
        if (filingStatus === 'Single' || filingStatus === 'MFS') {
          if (taxableIncome <= 9600) return 1.4;
          if (taxableIncome <= 14400) return 3.2;
          if (taxableIncome <= 19200) return 5.5;
          if (taxableIncome <= 24000) return 6.4;
          if (taxableIncome <= 36000) return 6.8;
          if (taxableIncome <= 48000) return 7.2;
          if (taxableIncome <= 125000) return 7.6;
          if (taxableIncome <= 175000) return 7.9;
          if (taxableIncome <= 225000) return 8.25;
          if (taxableIncome <= 275000) return 9;
          if (taxableIncome <= 325000) return 10;
          return 11;
        } else {
          if (taxableIncome <= 19200) return 1.4;
          if (taxableIncome <= 28800) return 3.2;
          if (taxableIncome <= 38400) return 5.5;
          if (taxableIncome <= 48000) return 6.4;
          if (taxableIncome <= 72000) return 6.8;
          if (taxableIncome <= 96000) return 7.2;
          if (taxableIncome <= 250000) return 7.6;
          if (taxableIncome <= 350000) return 7.9;
          if (taxableIncome <= 450000) return 8.25;
          if (taxableIncome <= 550000) return 9;
          if (taxableIncome <= 650000) return 10;
          return 11;
        }
      case 'Idaho': // Flat 5.3%
        return 5.3;
      case 'Illinois': // Flat 4.95%
        return 4.95;
      case 'Indiana': // Flat 2.95% (2026 update)
        return 2.95;
      case 'Iowa': // Flat 3.8%
        return 3.8;
      case 'Kansas':{ // 5.2% / 5.58%
        const threshold = (filingStatus === 'MFJ' || filingStatus === 'Married' || filingStatus === 'Joint') ? 46000 : 23000;
        if (taxableIncome <= threshold) return 5.2;
        return 5.58;
      }
      case 'Kentucky': // Flat 3.50% (2026 update)
        return 3.50;
      case 'Louisiana': // Flat 3.0%
        return 3.0;
      case 'Maine': // 5.8%/6.75%/7.15%
        if (taxableIncome <= 26800) return 5.8;
        if (taxableIncome <= 63450) return 6.75;
        return 7.15;
      case 'Maryland': // 2%-5.75%
        if (taxableIncome <= 1000) return 2;
        if (taxableIncome <= 2000) return 3;
        if (taxableIncome <= 3000) return 4;
        if (taxableIncome <= 100000) return 4.75;
        if (taxableIncome <= 125000) return 5;
        if (taxableIncome <= 150000) return 5.25;
        if (taxableIncome <= 250000) return 5.5;
        return 5.75;
      case 'Massachusetts': // 5% + 4% surtax >$1M = 9%
        if (taxableIncome > 1000000) return 9;
        return 5;
      case 'Michigan': // Flat 4.25%
        return 4.25;
      case 'Minnesota': // 5.35%-9.85%
        if (taxableIncome <= 32570) return 5.35;
        if (taxableIncome <= 106990) return 6.8;
        if (taxableIncome <= 198630) return 7.85;
        return 9.85;
      case 'Mississippi': // 0% <=$10k, 4.0% > (2026 update)
        if (taxableIncome <= 10000) return 0;
        return 4.0;
      case 'Missouri': // Graduated to 4.7%
        if (taxableIncome <= 1273) 
          return 0;
        else if (taxableIncome <= 2546) 
          return 2.0;
        else if (taxableIncome <= 3819) 
          return 2.5;
        else if (taxableIncome <= 5092) 
          return 3.0;
        else if (taxableIncome <= 6365) 
          return 3.5;
        else if (taxableIncome <= 7638) 
          return 4.0;
        else if (taxableIncome <= 8911) 
          return 4.5;
        else 
          return 4.7;
      case 'Montana':{ // 4.7% / 5.65% (2026 update, top reduced)
        let threshold = 47500; // Single/MFS
        if (filingStatus === 'MFJ' || filingStatus === 'Married' || filingStatus === 'Joint') {
          threshold = 95000;
        } else if (filingStatus === 'Head of Household') {
          threshold = 71250;
        }
        if (taxableIncome <= threshold) return 4.7;
        return 5.65;
      }
      case 'Nebraska': // 2026 update: top 4.55%, updated thresholds, fixed typo
        if (filingStatus === 'MFJ' || filingStatus === 'Married' || filingStatus === 'Joint') {
          if (taxableIncome <= 8040) return 2.46; // Approx 2026
          if (taxableIncome <= 48250) return 3.51;
          return 4.55;
        }
        if (filingStatus === 'Head of Household') {
          if (taxableIncome <= 7510) return 2.46;
          if (taxableIncome <= 38590) return 3.51;
          return 4.55;
        }
        // Single or MFS
        if (taxableIncome <= 4030) return 2.46;
        if (taxableIncome <= 24120) return 3.51;
        return 4.55;
      case 'Nevada': // No personal income tax
        return 0;
      case 'New Hampshire': // No more I&D tax
        return 0;
      case 'New Jersey': // 1.4%-10.75%
        if (taxableIncome <= 20000) return 1.4;
        if (taxableIncome <= 35000) return 1.75;
        if (taxableIncome <= 40000) return 3.5;
        if (taxableIncome <= 75000) return 5.525;
        if (taxableIncome <= 500000) return 6.37;
        if (taxableIncome <= 1000000) return 8.97;
        return 10.75;
      case 'New Mexico': // 1.5%-5.9%
        if (taxableIncome <= 5500) return 1.5;
        if (taxableIncome <= 16500) return 3.2;
        if (taxableIncome <= 33500) return 4.3;
        if (taxableIncome <= 66500) return 4.7;
        if (taxableIncome <= 210000) return 4.9;
        return 5.9;
      case 'New York': // 4%-10.9%
        if (taxableIncome <= 8500) return 4;
        if (taxableIncome <= 11700) return 4.5;
        if (taxableIncome <= 13900) return 5.25;
        if (taxableIncome <= 80650) return 5.5;
        if (taxableIncome <= 215400) return 6;
        if (taxableIncome <= 1077550) return 6.85;
        if (taxableIncome <= 5000000) return 9.65;
        if (taxableIncome <= 25000000) return 10.3;
        return 10.9;
      case 'North Carolina': // Flat 3.99% (2026 update)
        return 3.99;
      case 'North Dakota': // 1.95%/2.5%
        if (taxableIncome <= 244825) return 1.95;
        return 2.5;
      case 'Ohio': // 0% <=$26,050, then 2.75% (2026 update)
        if (taxableIncome <= 26050) return 0;
        return 2.75;
      case 'Oklahoma': // 2026 update: consolidated to three brackets, top 4.5%
        const isJointOrHead = (filingStatus === 'MFJ' || filingStatus === 'Married' || filingStatus === 'Joint' || filingStatus === 'Head of Household');
        if (!isJointOrHead) { // Single/MFS approx
          if (taxableIncome <= 3750) return 0; // Low effective, but marginal may start higher
          if (taxableIncome <= 4900) return 2.5;
          if (taxableIncome <= 7200) return 3.5;
          return 4.5;
        } else { // MFJ/HOH
          if (taxableIncome <= 7500) return 0;
          if (taxableIncome <= 9800) return 2.5;
          if (taxableIncome <= 14400) return 3.5;
          return 4.5;
        }
      case 'Oregon': // Top 9.9%
        if (taxableIncome <= 4400) return 4.75;
        if (taxableIncome <= 11050) return 6.75;
        if (taxableIncome <= 125000) return 8.75;
        return 9.9;
      case 'Pennsylvania': // Flat 3.07%
        return 3.07;
      case 'Rhode Island': // Top 5.99%
        if (taxableIncome <= 79900) return 3.75;
        if (taxableIncome <= 181650) return 4.75;
        return 5.99;
      case 'South Carolina': // Top 6.0% (2026 update)
        if (taxableIncome <= 3560) return 0;
        if (taxableIncome <= 17830) return 3;
        return 6.0;
      case 'South Dakota': // No personal income tax
        return 0;
      case 'Tennessee': // No personal income tax
        return 0;
      case 'Texas': // No personal income tax
        return 0;
      case 'Utah': // Flat 4.55%
        return 4.55;
      case 'Vermont': // Top 8.75%
        if (taxableIncome <= 47900) return 3.35;
        if (taxableIncome <= 116000) return 6.6;
        if (taxableIncome <= 242000) return 7.6;
        return 8.75;
      case 'Virginia': // Top 5.75%
        if (taxableIncome <= 3000) return 2;
        if (taxableIncome <= 5000) return 3;
        if (taxableIncome <= 17000) return 5;
        return 5.75;
      case 'Washington': // No personal income tax
        return 0;
      case 'West Virginia': // Top 4.82%
        if (taxableIncome <= 10000) return 2.36;
        if (taxableIncome <= 25000) return 2.96;
        if (taxableIncome <= 40000) return 3.33;
        if (taxableIncome <= 60000) return 4.44;
        return 4.82;
      case 'Wisconsin': // Top 7.65%
        if (taxableIncome <= 14680) return 3.5;
        if (taxableIncome <= 29370) return 4.4;
        if (taxableIncome <= 323290) return 5.3;
        return 7.65;
      case 'Wyoming': // No personal income tax
        return 0;
      case 'District of Columbia': // Top 10.75%
        const status = (filingStatus || '').trim().toLowerCase();
        if (status === 'estate' || status === 'trust') {
          if (taxableIncome <= 40000) return 6.5;
          if (taxableIncome <= 60000) return 8.5;
        }
        if (taxableIncome <= 10000) return 4;
        if (taxableIncome <= 40000) return 6;
        if (taxableIncome <= 60000) return 6.5;
        if (taxableIncome <= 250000) return 8.5;
        if (taxableIncome <= 500000) return 9.25;
        if (taxableIncome <= 1000000) return 9.75;
        return 10.75;
      default:
        return 0;
    }
  }

  getCorporateStateRate(state, filingStatus, taxableIncome, taxYear) {
    // 2026 updates: flat rates reduced in GA, NE, NC, PA
    switch (state) {
      case 'Alabama': 
        return 6.5;
      case 'Alaska': 
        return 0;
      case 'Arizona': 
        return 4.9;
      case 'Arkansas':
        if (taxableIncome <= 3000) return 1;
        if (taxableIncome <= 5000) return 2;
        if (taxableIncome <= 11000) return 3;
        return 4.3;
      case 'California': 
        return 8.84;
      case 'Colorado': 
        return 4.4;
      case 'Connecticut': 
        return 7.5;
      case 'Delaware': 
        return 8.7;
      case 'Florida': 
        return 5.5;
      case 'Georgia': 
        return 5.09; // 2026 update
      case 'Hawaii':
        if (taxableIncome <= 25000) return 4.4;
        if (taxableIncome <= 100000) return 5.4;
        return 6.4;
      case 'Idaho': 
        return 5.3;
      case 'Illinois': 
        return 9.5;
      case 'Indiana': 
        return 4.9;
      case 'Iowa':
        if (taxableIncome <= 100000) return 5.5;
        return 7.1;
      case 'Kansas':
        if (taxableIncome <= 50000) return 3.5;
        return 6.5;
      case 'Kentucky': 
        return 5;
      case 'Louisiana': 
        return 5.5;
      case 'Maine':
        if (taxableIncome <= 350000) return 3.5;
        if (taxableIncome <= 1050000) return 7.93;
        if (taxableIncome <= 3500000) return 8.33;
        return 8.93;
      case 'Maryland': 
        return 8.25;
      case 'Massachusetts':   
        return 8;
      case 'Michigan': 
        return 6;
      case 'Minnesota': 
        return 9.8;
      case 'Mississippi':
        if (taxableIncome <= 5000) return 3.0;
        if (taxableIncome <= 10000) return 4.0;
        return 5.0;
      case 'Missouri': 
        return 4;
      case 'Montana': 
        return 6.75;
      case 'Nebraska': 
        return 4.55; // 2026 update
      case 'Nevada': 
        return 0;
      case 'New Hampshire': 
        return 7.5;
      case 'New Jersey':
        if (taxableIncome > 1000000) return 11.5;
        return 9;
      case 'New Mexico': 
        return 5.9;
      case 'New York': 
        return 6.5;
      case 'North Carolina': 
        return 2.0; // 2026 update
      case 'North Dakota':
        if (taxableIncome <= 25000) return 1.41;
        if (taxableIncome <= 50000) return 3.55;
        return 4.31;
      case 'Ohio': 
        return 0;
      case 'Oklahoma': return 4;
      case 'Oregon':
        if (taxableIncome <= 1000000) return 6.6;
        return 7.6;
      case 'Pennsylvania': 
        return 7.49; // 2026 update
      case 'Rhode Island': 
        return 7;
      case 'South Carolina': 
        return 5;
      case 'South Dakota': 
        return 0;
      case 'Tennessee': 
        return 6.5;
      case 'Texas': 
        return 0;
      case 'Utah': 
        return 4.55;
      case 'Vermont':
        if (taxableIncome <= 10000) return 6;
        if (taxableIncome <= 25000) return 7;
        return 8.5;
      case 'Virginia': 
        return 6;
      case 'Washington': 
        return 0;
      case 'West Virginia': 
        return 6.5;
      case 'Wisconsin': 
        return 7.9;
      case 'Wyoming': 
        return 0;
      case 'District of Columbia': 
      return 8.25;
      default: 
      return 0;
    }
  }
}